import { cn } from '@/shared/lib/utils'

/** 制片项目壳层：卡片 / 面板黄色描边（与目录卡片一致） */
export const PRODUCTION_RING = 'ring-amber-400/50'
export const PRODUCTION_BORDER = 'border-amber-400/50'
export const PRODUCTION_BORDER_SUBTLE = 'border-amber-400/35'
export const PRODUCTION_BORDER_MUTED = 'border-amber-400/25'
export const PRODUCTION_BORDER_HOVER = 'hover:border-amber-400/70'

export const PRODUCTION_SHELL_CLASS = 'production-project-shell'

export const PRODUCTION_HERO_CLASS = cn(
  'mb-6 overflow-hidden rounded-2xl border bg-gradient-to-br from-amber-500/8 via-[#12121a] to-[#0b0b13] p-6 ring-1',
  PRODUCTION_BORDER,
  'ring-amber-400/40',
)

export const PRODUCTION_INSET_PANEL_CLASS = cn(
  'rounded-xl border bg-[#0e0e16] transition',
  PRODUCTION_BORDER_SUBTLE,
  PRODUCTION_BORDER_HOVER,
)

export const PRODUCTION_QUICK_LINK_CLASS = cn(
  'inline-flex items-center gap-2 rounded-xl border bg-muted/40 px-4 py-2.5 text-sm text-zinc-300 transition hover:text-amber-200',
  'border-amber-400/45 hover:border-amber-400',
)

export const PRODUCTION_TABLE_HEAD_CLASS = cn('border-b bg-[#12121a]', PRODUCTION_BORDER_SUBTLE)
export const PRODUCTION_TABLE_HEAD_ALT_CLASS = cn('border-b bg-[#0e0e16]', PRODUCTION_BORDER_SUBTLE)
export const PRODUCTION_TABLE_ROW_CLASS = cn('border-b', PRODUCTION_BORDER_MUTED)
export const PRODUCTION_TABLE_ROW_HOVER_CLASS = cn(PRODUCTION_TABLE_ROW_CLASS, 'hover:bg-white/[0.02]')

export const PRODUCTION_EMPTY_DASHED_CLASS = cn(
  'relative isolate overflow-visible rounded-2xl border border-dashed bg-[#12121a]/50',
  'border-amber-400/40',
  /** 上缘在父级 overflow / 邻接 Tab 下偶发被裁切时，inset ring 作兜底 */
  'ring-1 ring-inset ring-amber-400/25',
)

export const PRODUCTION_SEGMENTED_LIST_CLASS = cn(
  'overflow-visible border bg-[#12121a]/90 p-1.5',
  PRODUCTION_BORDER_SUBTLE,
)

export const PRODUCTION_SEGMENTED_TRIGGER_CLASS = cn(
  '!h-auto min-h-8 text-zinc-400 hover:text-zinc-200',
  'border border-transparent',
  'data-[state=active]:border-amber-400/35 data-[state=active]:bg-amber-500/15 data-[state=active]:text-amber-200 data-[state=active]:shadow-none',
  'dark:data-[state=active]:bg-amber-500/15',
)

export const PRODUCTION_CHIP_ACTIVE_CLASS =
  'border-amber-400/35 bg-amber-500/10 text-amber-200 hover:border-amber-400/45 hover:bg-amber-500/15 hover:text-amber-100'

export const PRODUCTION_CHIP_INACTIVE_CLASS = cn(
  'border bg-transparent',
  PRODUCTION_BORDER_MUTED,
  'text-zinc-400 hover:border-amber-400/45 hover:text-zinc-200',
)

export function productionCardClass(className?: string) {
  return cn('gap-0 p-5 shadow-sm', PRODUCTION_RING, className)
}

export function productionStatClass(className?: string) {
  return cn('rounded-2xl bg-card p-4 text-card-foreground shadow-sm ring-1', PRODUCTION_RING, className)
}

export function productionListTableClass(className?: string) {
  return cn('gap-0 overflow-hidden p-0 shadow-sm ring-1', PRODUCTION_RING, className)
}
